import { configureStore } from "@reduxjs/toolkit";
import userProfileReducer from "./Slices/userProfileSlice"; // Import the new slice reducer
import userSlice from "../../../common/redux/slices/userSlice";

const store = configureStore({
  reducer: {
    user: userSlice, // Existing user reducer
    userProfile: userProfileReducer, // New user profile reducer
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
